export const iconFontAwesomeHouseholdUtensils = (
	<i className="fa-solid fa-utensils"></i>
);
